import React from 'react';
import MediaQueries from 'react-responsive';

import Button from '@marvelapp/marvel-ui/button';
import Spacing from '@marvelapp/marvel-ui/spacing';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import SmartLink from 'marketing-website/components/modules/SmartLink';

import PowerfulDesignDesktop from './PowerfulDesignDesktop.js';
import PowerfulDesignMobile from './PowerfulDesignMobile.js';

export default function PowerfulDesign() {
  const Desktop = props => <MediaQueries {...props} minWidth={770} />;
  const Mobile = props => <MediaQueries {...props} maxWidth={770} />;

  return (
    <Spacing type="padding" size="xl" position="topBottom">
      <PageWrap>
        <HeadingBlock
          size="m"
          alignContent="center"
          alignM="center"
          spacing="m"
          title="Your design process, in one place"
          paragraphMaxWidth={540}
          copy={
            <span>
              Wireframe, design and prototype fast with our intuitive design and
              prototyping tools. Instantly generate design specs and connect
              integrations that power up your workflow. From low to
              high-fidelity, Marvel supports you every step of the way.
            </span>
          }
        >
          <Button shape="rounded" size="large">
            <SmartLink url="/why-marvel">
              <div className="c-white">Find out more</div>
            </SmartLink>
          </Button>
        </HeadingBlock>

        <Spacing size="xl" position="topBottom" type="margin">
          <Desktop>
            <PowerfulDesignDesktop />
          </Desktop>
          <Mobile>
            <PowerfulDesignMobile />
          </Mobile>
        </Spacing>
      </PageWrap>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/PowerfulDesign/index.js